import React from 'react';
import { CTAButton, Section, Countdown } from './Shared';
export function Hero() {
  return <div className="relative overflow-hidden bg-cream min-h-[90vh] flex items-center pt-20 pb-12 md:pt-24 md:pb-20" data-id="element-82">
      {/* Background Image — sleeping baby */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/k3ymEkYcx4kRPgfrBTZMJR/ChatGPT_Image_22_mar_2026,_07_10_20_p.m._(1).png")',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat'
    }} data-id="element-83"></div>

      {/* Darker Gradient Overlay for Readability */}
      <div className="absolute inset-0 z-0 bg-gradient-to-b md:bg-gradient-to-r from-cream via-cream/97 to-cream/60 md:to-cream/30" data-id="element-84"></div>
      <div className="absolute inset-0 z-0 bg-black/10" data-id="element-85"></div>

      <Section className="relative z-10 w-full !py-0" data-id="element-86">
        <div className="grid md:grid-cols-2 gap-12 md:gap-8 items-center" data-id="element-87">
          {/* Left Content */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-88">
            <h1 className="font-playfair text-4xl md:text-5xl lg:text-6xl text-charcoal font-medium leading-[1.1] mb-6 max-w-2xl" data-id="element-89">
              ¿Tu bebé se despierta toda la noche y vos{' '}
              <span className="text-sage-dark italic" data-id="element-90">ya no podés más?</span>
            </h1>

            <p className="text-lg md:text-xl text-charcoal-light mb-4 max-w-lg leading-relaxed" data-id="element-91">
              Descubrí cómo lograr que duerma mejor sin llanto ni estrés,
              respetando sus tiempos.
            </p>

            <p className="text-sm font-bold text-cta mb-8" data-id="element-92">
              ✅ Más de 1.000 mamás ya lograron que sus bebés duerman mejor
            </p>

            <div className="w-full md:w-auto flex flex-col items-center md:items-start" data-id="element-93">
              <Countdown data-id="element-94" />
              <CTAButton className="mt-2" data-id="element-95">
                QUIERO QUE MI BEBÉ DUERMA MEJOR
              </CTAButton>
              <p className="mt-4 text-sm text-charcoal-light font-medium" data-id="element-96">
                ⭐⭐⭐⭐⭐ +1.000 familias ya aplicaron este método
              </p>
            </div>
          </div>

          {/* Right Content - Transparent Product Mockup (larger + stronger shadow) */}
          <div className="relative flex justify-center md:justify-end" data-id="element-97">
            <img src="https://cdn.magicpatterns.com/uploads/oD4qsSVGjS78HJWdYtwqqj/ChatGPT_Image_10_mar_2026__20_13_23-removebg-preview.png" alt="Método Dormir sin Lágrimas - Ebook y Bonos" className="w-full max-w-lg md:max-w-xl h-auto object-contain drop-shadow-[0_12px_40px_rgba(0,0,0,0.2)] transform md:translate-x-4 scale-105 md:scale-110" data-id="element-98" />
          </div>
        </div>
      </Section>
    </div>;
}